export default __webpack_public_path__ + "static/media/ISEO CLASS-7 EXAM PATTERN 2025.1f52f5ac.pdf";